import React, { useRef, useEffect, useState, useMemo } from 'react';
import styles from './KeymastersPotView.module.scss';
import { Image } from 'src/ui/components';
import KeymastersPotContentContainer from './ContentContainer';
import KeymastersPotConnectWallet from './ConnectWallet';
import KeymastersPotCriteraNotMet from './CriteriaNotMet';
import KeymastersPotTabs from './Tabs';
// import { history, keys } from './data';
import keymastersPotAdvancedModeAtom from 'src/state/keymastersPotAdvancedModeAtom';
import { useRecoilState } from 'recoil';
import useContract from 'src/hooks/useContract';
import { CONTRACT_NAMES } from 'src/base/constants';
import LoadingOverlay from 'src/ui/components/LoadingOverlay';
import useUserCollections from 'src/hooks/useUserCollections'; // this makes the API call
import { trpcClient } from '../../../trpc/client';

// TODO; create a custom hook for this view

// note: address is already using active address (look at page component at ui/src/pages/odyssey/1/keymasters-pot/index.jsx)
export default function KeymastersPotView({ connect, address, network, provider, connected, criteriaNotMet, vault }) {
	const KeymastersPotRef = useRef(null);
	const [isAdvancedMode] = useRecoilState(keymastersPotAdvancedModeAtom);
	const [loading, setLoading] = useState(false);
	const potContract = useContract(provider, network, CONTRACT_NAMES.KEYMASTERS_POT);
	const potContractLoaded = potContract !== null;
	const { key: keyBalances, loading: balancesLoading } = useUserCollections(address, [CONTRACT_NAMES.KEY]);
	const [claimableAmounts, setClaimableAmounts] = useState(null);
	const [paused, setPaused] = useState(false);
	const keyIds = useMemo(() => keyBalances.map(x => Number(x.id), [keyBalances]));
	const [totalPotBalance, setTotalPotBalance] = useState(null);

	const history = []; // TODO: get this for real

	// TODO: fix this issue globally the remove this
	useEffect(() => {
		if (KeymastersPotRef.current) {
			document.body.style.minHeight = `${KeymastersPotRef.current.offsetHeight + 150}px`;
		}
	}, [KeymastersPotRef, isAdvancedMode, potContract]);


	useEffect(() => {
		if (!balancesLoading && claimableAmounts === null) {
			potContract?.claimableEth(keyIds).then(arr => {
				setClaimableAmounts(arr.map(x => Number(x)));
			});
		}
	}, [potContract, keyIds]);
	

	useEffect(() => {
	
		potContract?.paused().then((isPaused)=>{
			setPaused(isPaused)
		});

	}, [potContract]);

	useEffect(() => {
		if (!totalPotBalance && network) {
			try {
				trpcClient.getTotalPotBalance.query({ network }).then(result => {
					if (result) {
						setTotalPotBalance(result.balance);
					}
				});
			}
			catch (e) {
				console.log(`Error with keymaster pot balance retreival:${e}`)
			}
		}
	}, [network]);

	const keys = useMemo(() => {
		if (claimableAmounts === null) return [];
		if (keyIds.length === 0) return [];
		return keyIds.map((id, index) => ({ id, claimable: claimableAmounts[index] }));
	}, [keyIds, claimableAmounts]);


	return (
		<section ref={KeymastersPotRef}
			className={`w-screen h-auto bg-cover bg-center  ${styles['keymasters-pot-wrapper']}`}>

			<div className='w-full h-auto flex flex-col items-center justify-center'>
				<Image
					className='mt-10'
					src="/images/keymasters-pot/ApepeOdysseyGold.png"
					width={1220}
					height={280}
					alt="Apepe Odyssey Logo"
				/>

				<KeymastersPotContentContainer
					potBalance={totalPotBalance}
					paused={paused}
				>

					{!connected && <KeymastersPotConnectWallet connect={connect} />}
					{(connected && criteriaNotMet) && <KeymastersPotCriteraNotMet />}
					{connected && !criteriaNotMet && potContractLoaded && <KeymastersPotTabs history={history}
						keys={keys}
						claim={potContract?.claimEth}
						vault={vault}
						setLoading={setLoading}
						paused={paused}
					/>}

				</KeymastersPotContentContainer>
				{
					<LoadingOverlay
						show={loading}
						text="Claiming rewards"
					/>
				}
			</div>


		</section>
	);
}
